import PropTypes from "prop-types"
import React from "react"
import { fillCopy } from "src/main/Billing/PayInvoices/copy"

import Form from "src/components/Form"

const CardReaderProcessing = ({
  isCollecting,
  isReaderUnconfirmed = false,
  cardReaders,
  cardReaderId,
  errorMessage,
  copy,
}) => {
  const cardReaderName = cardReaders.find(
    (cardReader) => String(cardReader.id) === String(cardReaderId)
  )?.displayName

  const [namedHeading, unnamedHeading] = isReaderUnconfirmed
    ? [copy.connectingToReader, copy.connecting]
    : [copy.waitingOnReader, copy.waiting]
  const heading = cardReaderName
    ? fillCopy(namedHeading, { name: cardReaderName })
    : unnamedHeading

  return (
    <div className="flex flex-col items-center gap-3 py-8 text-center">
      {isCollecting ? (
        <>
          <i className="fa-kit fa-internet-wireless animate-pulse text-3xl text-blue-500" />
          <p className="m-0 text-base font-semibold">{heading}</p>
          {isReaderUnconfirmed ? null : (
            <p className="text-muted m-0">{copy.presentCard}</p>
          )}
        </>
      ) : (
        <p className="m-0 text-base font-semibold">{copy.stillProcessing}</p>
      )}
      {errorMessage ? <Form.Error>{errorMessage}</Form.Error> : null}
    </div>
  )
}

CardReaderProcessing.propTypes = {
  isCollecting: PropTypes.bool.isRequired,
  isReaderUnconfirmed: PropTypes.bool,
  cardReaders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      displayName: PropTypes.string,
    })
  ).isRequired,
  cardReaderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  errorMessage: PropTypes.string,
  copy: PropTypes.shape({
    connecting: PropTypes.string.isRequired,
    connectingToReader: PropTypes.string.isRequired,
    presentCard: PropTypes.string.isRequired,
    stillProcessing: PropTypes.string.isRequired,
    waiting: PropTypes.string.isRequired,
    waitingOnReader: PropTypes.string.isRequired,
  }).isRequired,
}

export default CardReaderProcessing
